/**
 * Helper function to generate plain object of any class instance.
 *
 * @param classInstance Any class instance
 * @returns plain object of the properties of the class
 */
export function getPlainObjectOf(classInstance: Object): object {
    let plainObj = {};
    for (const property in classInstance) {
        if (
            classInstance.hasOwnProperty(property) &&
            typeof classInstance[property] != "function"
        ) {
            plainObj[property] = classInstance[property];
        }
    }

    return plainObj;
}
